import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import trash from "../../../../images/icons/delete.svg";
import FAQsService from "../../../../services/StaticService";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";

const FAQs = () => {
	const initial = {
		question_en: "",
		question_ar: "",
		answer_en: "",
		answer_ar: "",
	};
	const [formData, setFormData] = useState([initial]);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const fAQsService = new FAQsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);

	useEffect(() => {
		setLoading(true);
		fAQsService
			.getList("faq")
			.then((res) => {
				if (res?.status) {
					let response = res?.data?.data?.data;
					if (!!response?.length) {
						setFormData(response);
					}
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, [shouldUpdate]);

	const submit = (e) => {
		e.preventDefault();

		let data = {
			faqs: formData?.map((res) => {
				return {
					question_en: res?.question_en,
					question_ar: res?.question_ar,
					answer_en: res?.answer_en,
					answer_ar: res?.answer_ar,
				};
			}),
		};
		fAQsService
			.create("faq", data)
			?.then((res) => {
				if (res?.status) {
					toast.success(res?.data?.message);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};
	const deleteFaq = (id) => {
		setLoading(true);
		fAQsService
			.remove("faq", id)
			.then((res) => {
				if (res?.status) {
					toast.success("Deleted Successfully");
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].faqs}
						</span>
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}
							{!loading && (
								<AvForm className="form-horizontal" onValidSubmit={submit}>
									{formData?.map((data, index) => {
										return (
											<Row key={index} className="mb-3">
												<Col
													md={12}
													className="mb-2 d-flex justify-content-between align-items-center">
													<p
														className="m-0"
														style={{ fontSize: "18px", color: "#000" }}>
														{Translate[lang].question} {index + 1}
													</p>
													<img
														src={trash}
														alt="trash"
														className="cursor-pointer"
														onClick={() => {
															if (!!data?.id) {
																if (isExist("delete_cms")) deleteFaq(data?.id);
															} else {
																setFormData((prev) => [
																	...prev?.filter((_, ind) => index !== ind),
																]);
															}
														}}
													/>
												</Col>
												<Col md={6}>
													<label className="text-label">
														{Translate[lang]?.question} (
														{Translate[lang]?.english})
													</label>
													<AvField
														type="textarea"
														placeholder={Translate[lang]?.english}
														bsSize="lg"
														style={{
															height: "100px",
														}}
														name={`question_en_${index}`}
														validate={{
															required: {
																value: true,
																errorMessage: Translate[lang].field_required,
															},
														}}
														value={data.question_en}
														onChange={(e) =>
															setFormData((prev) =>
																prev.map((res, ind) =>
																	ind === index
																		? { ...res, question_en: e.target.value }
																		: res
																)
															)
														}
													/>
												</Col>
												<Col md={6}>
													<label className="text-label">
														{Translate[lang]?.question} (
														{Translate[lang]?.arabic})
													</label>
													<AvField
														type="textarea"
														placeholder={Translate[lang]?.arabic}
														bsSize="lg"
														style={{
															height: "100px",
														}}
														name={`question_ar_${index}`}
														validate={{
															required: {
																value: true,
																errorMessage: Translate[lang].field_required,
															},
														}}
														value={data.question_ar}
														onChange={(e) =>
															setFormData((prev) =>
																prev.map((res, ind) =>
																	ind === index
																		? { ...res, question_ar: e.target.value }
																		: res
																)
															)
														}
													/>
												</Col>
												<Col md={6}>
													<label className="text-label">
														{Translate[lang]?.answer} (
														{Translate[lang]?.english})
													</label>
													<AvField
														type="textarea"
														placeholder={Translate[lang]?.english}
														bsSize="lg"
														style={{
															height: "100px",
														}}
														name={`answer_en_${index}`}
														validate={{
															required: {
																value: true,
																errorMessage: Translate[lang].field_required,
															},
														}}
														value={data.answer_en}
														onChange={(e) =>
															setFormData((prev) =>
																prev.map((res, ind) =>
																	ind === index
																		? { ...res, answer_en: e.target.value }
																		: res
																)
															)
														}
													/>
												</Col>
												<Col md={6}>
													<label className="text-label">
														{Translate[lang]?.answer} ({Translate[lang]?.arabic}
														)
													</label>
													<AvField
														type="textarea"
														placeholder={Translate[lang]?.arabic}
														bsSize="lg"
														style={{
															height: "100px",
														}}
														name={`answer_ar_${index}`}
														validate={{
															required: {
																value: true,
																errorMessage: Translate[lang].field_required,
															},
														}}
														value={data.answer_ar}
														onChange={(e) =>
															setFormData((prev) =>
																prev.map((res, ind) =>
																	ind === index
																		? { ...res, answer_ar: e.target.value }
																		: res
																)
															)
														}
													/>
												</Col>
												<Col md={12}>
													<hr />
												</Col>
											</Row>
										);
									})}
									<Button
										variant="outline-primary"
										type="button"
										onClick={() => setFormData((prev) => [...prev, initial])}
										className="mb-3 d-block mt-4">
										{Translate[lang]?.add} {Translate[lang]?.question}
									</Button>
									{isExist("add_cms") && (
										<Button variant="primary" type="submit" disabled={loading}>
											{Translate[lang]?.save}
										</Button>
									)}
								</AvForm>
							)}
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	);
};
export default FAQs;
